import React from 'react';
import { t } from 'i18next';

interface IFlagIcon {
  icon: string;
}

export const FlagIcon = ({ icon }: IFlagIcon) => {
  const altText = t('Flag icon for a specific country');

  return (
    <img
      src={icon}
      alt={altText}
      style={{
        width: '20px',
        height: '16px',
        borderRadius: '4px',
        marginRight: '6px',
      }}
    />
  );
};
